import { Link } from 'react-router-dom';
import { OPERATOR_URL, X_ACCOUNT, X_URL } from '../lib/links';
import { dial, siteContainer, textLink, wordmark } from '../lib/ui';

/**
 * サイトのフッター（`drawgon 公開サイト` のデザイン）。
 *
 * デザインとの違い:
 * - **「おといあわせ」を足した。** App Review 1.2 が連絡先の公開を求めている（#260、ADR-032 A1）
 *
 * 外へのリンクは新しいタブで開き、`noopener noreferrer` を付ける（開いた先から `window.opener` で
 * このページを書き換えられないように）。
 */
export function SiteFooter() {
  return (
    <footer className="mt-[clamp(72px,9vw,112px)] border-t-[3px] border-ink bg-surface">
      <div
        className={`${siteContainer} flex flex-wrap items-center justify-between gap-6 pt-8 pb-10`}
      >
        <div className="flex flex-wrap items-center gap-[18px]">
          <span className={`${wordmark} text-2xl`}>drawgon</span>
          <a
            href={X_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`drawgon の X アカウント（@${X_ACCOUNT}）`}
            className={`${dial} font-display text-[15px]`}
          >
            𝕏
          </a>
        </div>
        <nav
          aria-label="サイトの情報"
          className="flex flex-wrap items-center gap-[clamp(14px,3vw,28px)] text-sm"
        >
          <Link to="/rankings" className={textLink}>
            ランキング
          </Link>
          <Link to="/terms" className={textLink}>
            利用規約
          </Link>
          <Link to="/privacy" className={textLink}>
            プライバシーポリシー
          </Link>
          <Link to="/support" className={textLink}>
            おといあわせ
          </Link>
          <a href={OPERATOR_URL} target="_blank" rel="noopener noreferrer" className={textLink}>
            運営会社
          </a>
        </nav>
      </div>
      <div className={`${siteContainer} pb-8 text-[11.5px] text-text-muted`}>© drawgon</div>
    </footer>
  );
}
